//App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Projects from "./pages/Projects";
import CustomCursor from "./components/CustomCursor";
import "./App.css";  // Use the existing App.css

function App() {
  // Debug: Log the environment variable value
  console.log('REACT_APP_SITE_VISIBLE:', process.env.REACT_APP_SITE_VISIBLE);
  console.log('NODE_ENV:', process.env.NODE_ENV);
  
  // Check if site should be visible (try multiple ways)
  const isSiteHidden = process.env.REACT_APP_SITE_VISIBLE === 'false' || 
                      process.env.REACT_APP_SITE_VISIBLE === false ||
                      process.env.REACT_APP_SITE_VISIBLE === '0';
  
  if (isSiteHidden) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f5f5f5',
        color: '#333'
      }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Temporarily Unavailable</h1>
        <p style={{ fontSize: '1.2rem', textAlign: 'center', maxWidth: '600px' }}>
          Website is currently being updated.
        </p>
        <p style={{ fontSize: '1rem', marginTop: '2rem', color: '#666' }}>
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        <CustomCursor />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/projects" element={<Projects />} />
            <Route path="*" element={<Navigate to="/projects" replace />} />
          </Routes>
        </main>
        <Footer />
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
